import { render, staticRenderFns } from "./returnRule.vue?vue&type=template&id=f6903164&scoped=true"
import script from "./returnRule.vue?vue&type=script&lang=js"
export * from "./returnRule.vue?vue&type=script&lang=js"
import style0 from "./returnRule.vue?vue&type=style&index=0&id=f6903164&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6903164",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f6903164')) {
      api.createRecord('f6903164', component.options)
    } else {
      api.reload('f6903164', component.options)
    }
    module.hot.accept("./returnRule.vue?vue&type=template&id=f6903164&scoped=true", function () {
      api.rerender('f6903164', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customer/setup/ruleSettings/components/returnRule.vue"
export default component.exports